import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { CheckboxInput } from 'components/Common/Inputs/CheckboxInput';
import FieldChangeWrapper from 'components/Common/FieldChangeWrapper';

class NestedArrayBooleanFieldComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    normalize: PropTypes.func.isRequired,
    rootField: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    initValue: PropTypes.any,
    // eslint-disable-next-line react/forbid-prop-types
    state: PropTypes.any.isRequired
  };

  static defaultProps = {
    initValue: undefined
  };

  componentDidMount() {
    const {
      dispatch,
      state,
      form,
      rootField,
      initValue
    } = this.props;
    const selector = formValueSelector(form);
    const value = selector(state, rootField);
    if ((value === null || value === undefined) && initValue !== undefined) {
      dispatch(change(form, rootField, initValue));
    }
  }

  render() {
    const {
      name,
      normalize
    } = this.props;

    return (
      <Field
        name={ name }
        type="text"
        component={ FieldChangeWrapper }
        wrappedComponent={ CheckboxInput }
        iValue="true"
        className="form-input"
        onBlur={ (event, newVal, prevVal) => {
          if (!prevVal && !newVal) {
            event.preventDefault();
          }
        } }
        normalize={ normalize }
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = state => ({ state });

// eslint-disable-next-line import/prefer-default-export
export const NestedArrayBooleanField = connect(
  mapStateToProps,
  mapDispatchToProps
)(NestedArrayBooleanFieldComponent);
